import {
  CubeTransparentIcon,
  Flex,
  FlexProps,
  IconButton,
  MarkdownEditor,
  Panel,
  PanelProps,
  PencilSquareIcon,
  Text,
} from 'components'
import { useBreakpoint, useTheme } from 'utils'

interface Props extends Omit<PanelProps, 'children'> {
  title?: string
  /** markdown */
  description?: string
  infoText?: string
  infoTextProps?: FlexProps
  onEdit?: () => void
}

export default function ContentTile({
  title,
  description,
  infoText,
  infoTextProps,
  onEdit,
  ...props
}: Props) {
  const { theme } = useTheme()
  const breakpoint = useBreakpoint()

  return (
    <Panel
      flexDirection="row"
      borderRadius="sm"
      height="78px"
      px="30px"
      align="center"
      gap={3}
      {...(props.onClick && {
        cursor: 'pointer',
        _hover: { bg: 'gray.300' },
      })}
      {...props}
    >
      <CubeTransparentIcon />

      <Flex flex={1} direction={'column'} width={{ base: '27vw', sm: '35vw' }}>
        <Text
          textStyle={'bodyLarge'}
          fontWeight={'semibold'}
          width={{ base: '30vw', sm: '100%' }}
          textAlign={'left'}
          overflow={'hidden'}
          textOverflow={'ellipsis'}
        >
          {title}
        </Text>

        {description && breakpoint > 0 && (
          <Flex maxHeight={'40px'}>
            <MarkdownEditor value={description} readOnly lineClamp={1} />
          </Flex>
        )}
      </Flex>

      {onEdit && (
        <IconButton
          aria-label="edit content"
          icon={<PencilSquareIcon />}
          onClick={onEdit}
          borderRadius={'10px'}
          h={'40px'}
          p={3}
          bg={theme === 'light' ? 'rgba(255, 255, 255, 0.54)' : ''}
          boxShadow={'0px 1px 4px 0px rgba(0, 0, 0, 0.06)'}
        />
      )}

      {infoText && (
        <Flex
          p={2}
          borderRadius={'44px'}
          border={theme === 'light' ? '1px solid #D0D0D0' : '1px solid rgba(255,255, 255, 0.30)'}
          boxShadow={'0px 1px 4px 0px rgba(0, 0, 0, 0.06)'}
          hideBelow="sm"
          {...infoTextProps}
          {...(infoTextProps?.onClick && {
            cursor: 'pointer',
            _hover: { bg: 'rgba(255, 255, 255, 0.54)' },
            onClick: e => {
              e.stopPropagation()
              infoTextProps.onClick?.(e)
            },
          })}
        >
          <Text width={'135px'} textStyle={'bodySmall'} textAlign={'center'}>
            {infoText}
          </Text>
        </Flex>
      )}
    </Panel>
  )
}
